const baseUrl = process.env.REACT_APP_BASE_URL || '';

/** slug → label from GET /api/public/discussion-starter-categories */
let labelBySlug = null;
let loadPromise = null;

function applyCategories(list) {
  const map = Object.create(null);
  for (const c of list || []) {
    const key = String(c?.key || '').trim();
    if (!key) continue;
    map[key] = String(c.label || '').trim() || key;
  }
  labelBySlug = map;
  return map;
}

/** Load starter club labels from the backend (no auth). Safe to call multiple times. */
export function loadStarterClubCatalog() {
  if (labelBySlug) return Promise.resolve(labelBySlug);
  if (loadPromise) return loadPromise;
  loadPromise = fetch(`${baseUrl}/api/public/discussion-starter-categories`, {
    credentials: 'include',
  })
    .then((res) => res.json().catch(() => ({})))
    .then((data) => {
      if (data?.success && Array.isArray(data.categories)) {
        return applyCategories(data.categories);
      }
      return applyCategories([]);
    })
    .catch(() => applyCategories([]));
  return loadPromise;
}

export function isStarterClubCatalogLoaded() {
  return labelBySlug != null;
}

export function getStarterClubLabel(slug) {
  const key = String(slug || '').trim();
  if (!key || !labelBySlug) return '';
  return labelBySlug[key] || '';
}

/** Rows for club picker before /discussions/categories returns. */
export function getStarterClubPickerRows() {
  if (!labelBySlug) return [];
  return Object.entries(labelBySlug).map(([key, label]) => ({
    key,
    label,
    thumbnailUrl: '',
  }));
}

/** Optional: hydrate from guest-posts-config if already fetched elsewhere. */
export function hydrateStarterClubCatalog(categories) {
  if (!Array.isArray(categories) || !categories.length) return labelBySlug;
  return applyCategories(categories);
}
